// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"2084f89a","279":"be4e55d8","344":"baa243a4","428":"993a6673","932":"ac89ef79"}[chunkId] + ".chunk.js";
};